module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Melissa Ostrom\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Melissa Ostrom")]), _vm._v(" teaches English literature at Genesee Community College in Batavia, New York. Her short fiction has been published in literary magazines, and nominated for a Pushcart Prize. "), _c('I', [_vm._v("The Beloved Wild")]), _vm._v(" is her YA debut. She lives in Batavia, New York, with her family.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dMUdb/tc-custom/9781250132802.jpg?1729034209207",
      "alt": "This image is the cover for the book Beloved Wild"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beloved Wild\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A debut YA American epic and historical adventure from Melissa Ostrom about striking out for your own destiny. "), _c('b', [_c('br'), _c('br'), _vm._v("She's not the girl everyone expects her to be.")]), _c('br'), _c('br'), _vm._v("Harriet Winter is the eldest daughter in a farming family in New Hampshire, 1807. She is expected to help with her younger sisters. To pitch in with the cooking and cleaning. And to marry her neighbor, the farmer Daniel Long. Harriet’s mother sees Daniel as a good match, but Harriet doesn’t want someone else to choose her path—in love or in life. "), _c('br'), _c('br'), _vm._v("When Harriet’s brother decides to strike out for the Genesee Valley in Western New York, Harriet decides to go with him—disguised as a boy. Their journey includes sickness, uninvited strangers, and difficult emotional terrain as Harriet sees more of the world, realizes what she wants, and accepts who she’s loved all along.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Feiwel and Friends\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0